<template><svg xmlns="http://www.w3.org/2000/svg" width="42.487" height="31.69" viewBox="0 0 42.487 31.69">
    <g transform="translate(-233.75 -550.279)">
        <g transform="translate(234.75 551.279)" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2">
            <path d="M272.538,570.775a2.7,2.7,0,0,0,2.7-2.7v-4.05a3.261,3.261,0,0,0-.954-2.3l-4.445-4.445h-29.69l-4.445,4.445a3.261,3.261,0,0,0-.954,2.3v4.05a2.7,2.7,0,0,0,2.7,2.7Z"
                  transform="translate(-234.75 -546.482)"/>
            <path d="M234.912,560.279H241.6a2.7,2.7,0,0,1,1.907.79l1.909,1.909"
                  transform="translate(-234.62 -544.084)"/>
            <path d="M261.755,560.279h-6.688a2.7,2.7,0,0,0-1.907.79l-1.909,1.909"
                  transform="translate(-221.56 -544.084)"/>
            <path d="M237.75,562.075l3.059-8.169a4.047,4.047,0,0,1,3.795-2.627h15.982a4.047,4.047,0,0,1,3.79,2.627l3.059,8.169Z"
                  transform="translate(-232.352 -551.279)"/>
            <path d="M240.148,558.478l-2.7-2.7h-2.7" transform="translate(-234.75 -547.682)"/>
            <path d="M254.25,558.478l2.7-2.7h2.7" transform="translate(-219.161 -547.682)"/>
            <path d="M236.25,564.779v2.7a2.7,2.7,0,1,0,5.4,0v-2.7Z" transform="translate(-233.551 -540.487)"/>
            <path d="M258.148,564.779v2.7a2.7,2.7,0,1,1-5.4,0v-2.7Z"
                  transform="translate(-220.361 -540.487)"/>
        </g>
    </g>
</svg>
</template>